import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export const OrderButton = ({
  label = 'Start Your Order',
  testid = 'start-order-button',
  className = '',
  size = 'lg',
}) => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate('/order')}
      size={size}
      data-testid={testid}
      className={`bg-blue-600 hover:bg-blue-700 text-white font-semibold transition-all duration-200 transform hover:scale-105 ${className}`}
    >
      {label}
      <ArrowRight className="ml-2 h-5 w-5" />
    </Button>
  );
};

export const OrderCTABanner = ({ testid = 'cta-banner-order-button' }) => {
  return (
    <section className="bg-gradient-to-r from-blue-700 via-blue-600 to-sky-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 text-center">
        <h3 className="text-3xl sm:text-4xl font-bold text-white mb-3">
          Ready to bring your brand to life?
        </h3>
        <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
          No minimums. Free design proof. Start your custom order in just a few quick steps.
        </p>
        <OrderButton
          label="Start Your Order"
          testid={testid}
          className="bg-white !text-blue-700 hover:bg-blue-50 px-10 py-5 text-lg"
        />
      </div>
    </section>
  );
};
